// extracted by mini-css-extract-plugin
module.exports = {"EditorialTitleParagraphCta":"styles_EditorialTitleParagraphCta__QjVpk","title":"styles_title__8eRCp","cta":"styles_cta__dBacK","subtitle":"styles_subtitle__rZs93"};